import { z } from 'zod';
import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { Currency } from '@40seas/models';

export const HeronReportAnnualRevenueSchema = z
    .object({
        amount: z.number(),
        currency: EnumSchema(Currency),
    })
    .strict();

export class HeronReportAnnualRevenue extends FromSchema(HeronReportAnnualRevenueSchema) {
    amount: number;
    currency: Currency;
}
